import { Button, Trash } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { styled } from 'styled-components'

type DeleteButtonProps = {
  onClick: () => void
  children?: string
  testId?: string
}

export const DeleteButton = ({
  onClick,
  children,
  testId
}: DeleteButtonProps) => {
  return (
    <StyledButton onClick={onClick} data-testid={testId}>
      <Trash />
      <Text weight="medium">{children}</Text>
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  padding: 0;
  border: none;
  background: none;
  color: ${(props) => props.theme.color.neutral.color4};
`
